import { makeConfigRef } from './util.make-config-ref.js';

function combineConfigRefs(input) {
  const inputEntries = Object.entries(input);
  function combineValues() {
    const entries = inputEntries.map(([key, configRef]) => {
      return [key, configRef == null ? void 0 : configRef.get()];
    });
    if (entries.some(([, value]) => value instanceof Promise)) {
      return Promise.all(entries).then(
        (resolvedEntries) => Object.fromEntries(resolvedEntries)
      );
    } else {
      return Object.fromEntries(entries);
    }
  }
  const combinedConfigRef = makeConfigRef(() => combineValues());
  inputEntries.forEach(([, configRef]) => {
    configRef == null ? void 0 : configRef.observe(() => {
      combinedConfigRef.__update(combineValues());
    });
  });
  return combinedConfigRef;
}

export { combineConfigRefs };
//# sourceMappingURL=util.combine-config-refs.js.map
